<template>
  <div class="introduction">
    <div class="detail">
      <div class="teacher common" v-if="teacherList.length > 0">
        <div class="commonTop">
          <h5><span>主讲老师</span></h5>
        </div>
        <div class="commonContent">
          <ul>
            <li
              v-for="(item, index) in teacherList"
              :key="index"
              @click="goArthome(item)"
            >
              <div class="img">
                <img
                  :src="courseType == 1000 ? item.image : item.teacherimage"
                  alt=""
                />
              </div>
              <div class="info">
                <p class="name ellipsis">
                  {{ courseType == 1000 ? item.name : item.teachername }}
                </p>
                <p class="des ellipsis">
                  {{ courseType == 1000 ? item.title : item.title }}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="common introduction">
        <div class="commonTop">
          <h5><span>课程简介</span></h5>
        </div>
        <div class="commonContent" v-html="info.profile"></div>
      </div>
      <div class="common tool" v-if="tool.length > 0">
        <div class="commonTop">
          <h5><span>配套商品</span></h5>
        </div>
        <div class="commonContent">
          <ul>
            <li v-for="(item, index) in tool" :key="index">
              <div class="img"><img :src="item.image" /></div>
              <div class="info">
                <div>
                  <p class="name ellipsis">{{ item.productname }}</p>
                  <p class="des ellipsis">{{ item.subtitle }}</p>
                </div>
                <div>
                  <p class="price">
                    <em>¥ </em
                    ><span>{{ util.toFixed(item.sellprice, 2) }}</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="common recommend" v-if="recommend.length > 0">
        <div class="commonTop">
          <h5><span>相关推荐</span></h5>
        </div>
        <div class="commonContent">
          <ul
            :class="[
              'clearfix',
              courseType == 1000 ? 'courseRecommend' : 'packageRecommend',
            ]"
          >
            <li
              v-for="(item, index) in recommend"
              :key="index"
              @click="showCourse(item)"
            >
              <CourseLabel
                :courseInfo="item"
                :courseType="courseType"
              ></CourseLabel>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CourseLabel from "@/components/courseLabel";

export default {
  props: ["info", "courseType"],
  data() {
    return {
      tool: [],
      recommend: [],
      sellingprice: "",
      marketprice: "",
      teacherList: [],
      coupons: [],
    };
  },
  components: {
    CourseLabel,
  },
  mounted() {
    if (this.courseType == 1000) {
      this.getTool();
    }
    this.getRecommend();
    this.showData();
  },
  watch: {
    ["info"]() {
      this.showData();
    },
  },
  methods: {
    showData() {
      var info = this.info;
      switch (this.courseType - 0) {
        case 1000:
          this.sellingprice = info.coursepricedtoes && info.coursepricedtoes[0].sellingprice;
          this.marketprice =info.coursepricedtoes && info.coursepricedtoes[0].marketprice;
          this.teacherList=[info.teacher];
          break;
        case 1003:
          this.sellingprice =info.packageprices && info.packageprices[0].sellingprice;
          this.marketprice =info.packageprices && info.packageprices[0].marketprice;
          this.teacherList = info.teacherroyalties;
          break;
        default:
          break;
      }
    },
    getTool() {
      var obj = {
        businesstype: 2000,
        businessid: this.info.courseid,
        salestype: 1002,
        pageNum: 1,
        pageSize: 9,
      };
      this.$post(
        "iart-api-scm/api/scm/product/queryBySpuProductList",
        obj
      ).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            var data = res.data && res.data.rows ? res.data.rows : [];
            this.tool = data;
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    getRecommend() {
      var obj = {},
        url = "";
      switch (this.courseType - 0) {
        case 1002:
        case 1001:
        case 1000:
        case 1005:
          url = "iart-api-scm/api/scm/course/querySimilarCourse";
          obj = {
            courseid: this.info.courseid,
            lclasscode: this.info.lclasscode,
            mclasscode: this.info.mclasscode,
            sclasscode: this.info.sclasscode,
            pageNum: 1,
            pageSize: 3,
          };
          break;
        case 1003:
          url = "iart-api-scm/api/scm/package/queryCoursePackages";
          obj = {
            packageid: this.info.packageid,
            sclasscode: this.info.sclasscode,
            pageNum: 1,
            pageSize: 3,
          };
          break;

        default:
          break;
      }
      this.$post(url, obj).then((res) => {
        if (res.code == 1) {
          if (this.courseType == 1003) {
             var data = res.data && res.data.rows ? res.data.rows : [];
            this.recommend = data;
          } else {
            this.recommend = res.data;
          }
          this.$emit("evaluationCallback", { type: "reload" });
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
  
    showCourse(item) {
      if (this.courseType == 1003) {
        var url = "/#/h5/course/coursePackage?packageId=" + item.packageid;
        history.replaceState({ packageId: item.packageid }, "", url);
      } else {
        var url ="/#/h5/course/courseDetail?courseId=" +item.courseid +"&courseType=1000";
        history.replaceState({ courseId: item.courseid, courseType: 1000 },"",url);
      }
      window.location.reload();
    },
    receiveCoupons(item) {
      var productid =this.courseType == 1000? this.info.coursepricedtoes[0].productid: this.info.packageprices[0].productid;
      var obj = {
        businesstype: 2000,
        couponid: item.couponid,
        businessid: productid,
      };
      this.$post("/iart-api-oaf/api/oaf/customer/receiveCoupon", obj).then(
        (res) => {
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              item.receiveCount = "Y";
              this.util.toast({ msg: "已领取该优惠券" });
            } else {
              this.util.toast({ msg: res.data.rtnmsg });
            }
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    goArthome(item) {
      if (item.arthome == "Y") {
        var obj = {
          this: this,
          loginStatus: false,
          url: "/h5/course/artHome/artHome",
          query: { teacherId: item.teacherid },
        };
        this.util.goto(obj);
      } else {
        this.util.toast({ msg: "该老师暂未开通艺术家之家" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.introduction {
  padding: 0 16px;
  .detail {
    margin-top: 30px;
    .common {
      margin-bottom: 24px;
      .commonTop {
        h5 {
          position: relative;
          span {
            font-size: 14px;
            line-height: 20px;
            font-weight: bolder;
            color: rgba(134, 135, 138, 1);
            background: #fff;
            padding-right: 8px;
            z-index: 10;
          }
        }
        h5::before {
          content: " ";
          display: inline-block;
          width: 100%;
          height: 1Px;
          background: rgba(224, 224, 224, 1);
          position: absolute;
          top: 50%;
          right: 0;
          z-index: -1;
        }
      }
      .commonContent {
        margin-top: 12px;
      }
    }
    .teacher {
      .commonContent {
        border: 0.5Px solid rgba(151, 151, 151, 0.2);
        border-radius: 3Px;
        li {
          display: flex;
          flex-direction: row;
          border-radius: 4Px;
          padding: 16px 0 16px 16px;
          .img {
            img {
              width: 60px;
              height: 60px;
              object-fit: cover;
              border-radius: 50%;
            }
          }
          .info {
            flex: 1;
            overflow: hidden;
            margin-left: 16px;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-right: 56px;
            .name {
              font-size: 16px;
              line-height: 22px;
              color: rgba(51, 54, 51, 1);
              font-weight: 600;
            }
            .des {
              font-size: 12px;
              line-height: 17px;
              color: rgba(51, 54, 51, 0.6);
              margin-top: 3px;
            }
          }
          .info::before {
            content: " ";
            display: inline-block;
            width: 24px;
            height: 24px;
            background: url(../../../../assets/img/h5/arrow_r_darkgray.png) no-repeat;
            background-size: 24px 24px;
            position: absolute;
            right: 16px;
            top: 50%;
            margin-top: -12px;
          }
        }
        li:not(:last-child) .info {
          border-bottom: 0.5Px solid rgba(224, 224, 224, 1);
        }
      }
    }
    .introduction {
      font-size: 14px;
      line-height: 26px;
      color: #666666;
      padding: 0;
      img,
      image {
        max-width: 100%;
      }
    }
    .tool {
      .commonContent {
        ul {
          li {
            display: flex;
            flex-direction: row;
            .img {
              display: inline-block;
              width: 100px;
              height: 100px;
              border-radius: 3Px;
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .info {
              flex: 1;
              overflow: hidden;
              margin-left: 16px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .name {
                font-size: 14px;
                line-height: 18px;
                color: rgba(53, 54, 60, 1);
                font-weight: bolder;
              }
              .des {
                font-size: 12px;
                line-height: 17px;
                color: rgba(53, 54, 60, 0.6);
                margin-top: 4px;
              }
              .price {
                color: rgba(53, 54, 60, 1);
                em {
                  font-size: 12px;
                  line-height: 15px;
                }
                span {
                  font-size: 16px;
                  line-height: 20px;
                  font-weight: bolder;
                }
              }
            }
          }
          li:not(:last-child) {
            margin-bottom: 24px;
          }
        }
      }
    }
    .recommend {
      .commonContent {
        // .courseRecommend {
        li {
          margin-bottom: 24px;
          // }
        }
      }
    }
  }
}
</style>

